import { Component } from '@angular/core';
import { LoaderService } from "../core/services/loader.service";
import { Observable } from "rxjs";
import { SplashScreen } from '@capacitor/splash-screen';
import { SafeArea } from 'capacitor-plugin-safe-area';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent {
  loading$: Observable<boolean>;

  constructor(private loaderService: LoaderService) {
    this.loading$ = this.loaderService.updateLoader$;
    this.splashScreenHandler().then(()=>{});
  }
  async adjustLayout(){
      const {insets}=await SafeArea.getSafeAreaInsets();
      document.documentElement.style.setProperty('--safe-top',`${insets.top}px`);
  }
  async splashScreenHandler() {
    await this.adjustLayout();
    await SplashScreen.show({
      showDuration: 3000,
      autoHide: true
    });

    setTimeout(async () => {
      await SplashScreen.hide();
    }, 3000);
  }
}
